import React, { Component } from "react";
import Filters from "components/common/Filters";
import StartupCard from "components/common/StartupCard/StartupCard";
import Api from "Api/Api";
import Utils from "Utils";
import AddBidForm from "components/InvestorComponents/AddBidForm";
import { Popup } from "devextreme-react";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return {
    section: state.section,
    filters: state.filters,
    search: state.search,
  };
}
class AdminSecondaryStake extends Component {
  constructor(props) {
    super(props);
    this.startup_original_data = {};
    this.state = {
      open: [],
      pipeline: [],
      committed: [],
      sold: [],
      showPopup: false,
      popupData: {},
    };
    this.togglePopup = (startupData) => {
      if (startupData) {
        this.setState({ popupData: startupData });
      }
      this.setState({
        showPopup: !this.state.showPopup,
      });
    };
    this.renderPopupContent = () => {
      return (
        <AddBidForm
          startup={this.state.popupData}
          upForSale={this.togglePopup}
        />
      );
    };
    this.changeStartupStatus = (startup_data, prevType, openType) => {
      Api.changeStartupStatus(openType, startup_data.id).then((response) => {
        if (response.status === 200) {
          var deleted_startup_values = this.state[prevType].filter(
            (startup) => {
              return startup.id !== startup_data.id;
            }
          );
          this.setState({
            [prevType]: deleted_startup_values,
            [openType]: [...this.state[openType], startup_data],
          });
        }
      });
    };
  }
  componentDidMount() {
    this.props.dispatch({ type: "toggleLoad" });
    Api.getAllSellingStartup().then((response) => {
      this.props.dispatch({ type: "toggleLoad" });
      if (response.status === 200) {
        this.startup_original_data = response.data;
        this.setState({
          open: response.data.open || [],
          sold: response.data.sold || [],
          pipeline: response.data.pipeline || [],
        });
        Utils.highlighter(this.props.location.state);
      }
    });

    this.props.dispatch({
      type: "SectionSelected",
      payload: "Dashboard",
    });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.search !== "" || Object.keys(nextProps.filters).length) {
      if (nextProps.search !== "") {
        Object.keys(this.state).forEach((type) => {
          this.setState({
            [type]: Utils.search(
              nextProps.search,
              this.startup_original_data[type]
            ),
          });
        });
      }
      if (nextProps.filters && Object.keys(nextProps.filters).length) {
        Api.filterStartup(nextProps.filters).then((response) => {
          if (response.status === 200) {
            Object.keys(this.state).forEach((type) => {
              this.setState({
                [type]: Utils.filter(
                  response.data,
                  this.startup_original_data[type]
                ),
              });
            });
          }
        });
      }
    } else {
      Object.keys(this.startup_original_data).forEach((type) => {
        this.setState({
          [type]: this.startup_original_data[type],
        });
      });
    }
  }
  render() {
    return (
      <div className="row">
        <div className="col-lg-12">
          <Filters />
          <div className="card">
            <div className="card-header card-header-tabs card-header-primary">
              <div className="nav-tabs-navigation">
                <div className="nav-tabs-wrapper">
                  <ul className="nav nav-tabs row" data-tabs="tabs">
                    <li className="nav-item col-lg-4 text-center">
                      <a
                        className="nav-link active"
                        href="#open"
                        data-toggle="tab"
                      >
                        <i className="material-icons">star_border</i> Open
                        <div className="ripple-container"></div>
                      </a>
                    </li>
                    <li className="nav-item col-lg-4 text-center">
                      <a
                        className="nav-link"
                        href="#pipeline"
                        data-toggle="tab"
                      >
                        <i className="material-icons">wb_cloudy</i> Pipeline
                        <div className="ripple-container"></div>
                      </a>
                    </li>
                    <li className="nav-item col-lg-4 text-center">
                      <a className="nav-link" href="#sold" data-toggle="tab">
                        <i className="material-icons">close</i> Sold
                        <div className="ripple-container"></div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="tab-content">
                <div className="tab-pane active" id="open">
                  <div className="row">
                    {this.state.open.length ? (
                      this.state.open.map((data) => {
                        return (
                          <div className="col-lg-3">
                            <StartupCard
                              type="open"
                              key={data.id}
                              data={data}
                              action={this.changeStartupStatus}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <h4 className="no-data-text">No Data</h4>
                    )}
                  </div>
                </div>
                <div className="tab-pane" id="pipeline">
                  <div className="row">
                    {this.state.open.length ? (
                      this.state.open.map((data) => {
                        return (
                          <div className="col-lg-3">
                            <StartupCard
                              type="pipeline"
                              key={data.id}
                              data={data}
                              action={this.changeStartupStatus}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <h4 className="no-data-text">No Data</h4>
                    )}
                  </div>
                </div>
                <div className="tab-pane" id="sold">
                  <div className="row">
                    {this.state.sold.length ? (
                      this.state.sold.map((data) => {
                        return (
                          <div className="col-lg-3">
                            <StartupCard
                              type="sold"
                              key={data.id}
                              data={data}
                              action={this.changeStartupStatus}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <h4 className="no-data-text">No data</h4>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Popup
          visible={this.state.showPopup}
          onHiding={this.togglePopup}
          closeOnOutsideClick={true}
          title={"Send for bidding"}
          height={"auto"}
          width={"auto"}
          contentComponent={this.renderPopupContent}
          showCloseButton={true}
        />
      </div>
    );
  }
}
export default connect(mapStateToProps)(AdminSecondaryStake);
